// test2622
(2622 && 0);
